import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getStaffList } from '@store/modules/staff_list';
import { queryExportHr } from '@api/hr/hr';
import ComponentOrg from '../hr/staff/ComponentOrg';
import ComponentStaff from '../hr/staff/ComponentStaff';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    this.current = 1;
    this.condition = '';
    this.orgUuid = '';
  }

  componentDidMount() {
    this.getHr();
  }

  getHr = () => {
    const { dispatch } = this.props;
    dispatch(
      getStaffList({
        current: this.current,
        condition: this.condition,
        orgUuid: this.orgUuid,
        status: 1,
      }),
    );
  };

  exportHr = () => {
    queryExportHr({ orgUuid: this.orgUuid || '' });
  };

  handleSearch = value => {
    this.condition = value;
    this.current = 1;
    this.getHr();
  };

  handleTableChange = pagination => {
    this.current = pagination.current;
    this.getHr();
  };

  handleOrgChange = value => {
    this.orgUuid = value[0];
    this.getHr();
  };

  render() {
    return (
      <div style={{ display: 'flex' }} className="pageStaff">
        <div style={{ width: '300px', marginRight: '16px' }}>
          <ComponentOrg handleChange={this.handleOrgChange} />
        </div>
        <div style={{ flex: 1 }}>
          <ComponentStaff
            type="resource"
            getHr={this.getHr}
            handleSearch={this.handleSearch}
            handleTableChange={this.handleTableChange}
            exportHr={this.exportHr}
            noEdit
          />
        </div>
      </div>
    );
  }
}

export default connect(state => ({ data: state.staff_list }))(Index);



// WEBPACK FOOTER //
// ./src/components/resource/PageAddress.js